import { composeClassNames } from "@faedev/editor-utils";
import { CSSProperties, ReactNode } from "react";
import { sPage } from "src/styles/sPage.module.scss";

type Props = {
  style?: CSSProperties | null | undefined;
  className?: (string | string) | null | undefined;
  children?: ReactNode;
};

function Page({ style, className, children }: Props) {
  return (
    <div
      className={composeClassNames([sPage, className, "page"])}
      style={style}
    >
      {children}
    </div>
  );
}

export default Page;
